import { useMemo } from 'react'

import { useCart } from '@/entities/cart'

import { useGetLocalCartItems } from '@/shared/lib/hooks/useGetLocalCartItems'

export const useGetRelatedProducts = (id: number) => {
	const localItems = useGetLocalCartItems(id)
	const { products } = useCart()
	const relatedProducts = useMemo(
		() => [...localItems, ...products].filter(item => item.RELATED_PRODUCTS === id),
		[localItems, products, id]
	)

	return relatedProducts
}
